import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import * as jQuery from 'jquery';

export interface OverviewSummaryModel {
	productId: number;
	parentIndex: number;
	parentClass: string;
	mainId: number;
	isParent: boolean;
	productName: string;
	impressions: number;
	clicks: number;
	clickRate: string;
	viewThroughs: number;
	viewThroughRate: string;
	visits: number;
	visitRate: string;
	exposures: number;
	order: number;
	adplays: number;
}

@Component({
	selector: 'app-overview-summary',
	styleUrls: ['./overview-summary.component.css'],
	templateUrl: './overview-summary.component.html'
})
export class OverviewSummaryComponent implements WidgetCore, OnInit, OnDestroy {
	@Input() permissionedquerykeys: any;
	@Input() sectionclass: string;
	@Input() legend: any;
	public key: string;
	public colors: string;
	public showLoad = true;
	public isNaN: Function;
	public summaryData: OverviewSummaryModel[] = [];
	public tooltipOptions = {
		animation: 'fade',
		arrow: true,
		duration: 750,
		dynamicTitle: true,
		position: 'top',
		scale: 'big'
	};
	public isR101: boolean = false;
	public partnerColors: string[] = [];
	public reloadSubscription;
	public widgetDataSubscription;
	public hasExposureColumn: boolean = false;
	public gamProductName: string = 'GAM';
	public isR8: boolean = false;
	public isR1: boolean = false;
	public isDOOHenabled: boolean = false;
	public dooh_permission: object = { permission: { flags: ['hasDOOH'] } };
	public hasDoohCampaigns: boolean = false;
	public isR104: boolean = false;
	private exposureColumnPartners: string[] = ['Midco'];
	public isEntravisionR103: boolean = false;
	private productsOrder: any = {
		Television: 1,
		Display: 2,
		'Pre Roll': 3,
		'Connected TV': 4,
		Social: 5,
		'Streaming Audio': 6,
		Total: 7
	};

	constructor(public analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		this.isNaN = Number.isNaN;
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});

		this.hasExposureColumn =
			this.exposureColumnPartners.findIndex((partner_name) => {
				return partner_name === this.analyticsDataModel.config.partner.partnerName;
			}) !== -1;
	}

	ngOnInit(): void {
		this.partnerColors = this.colors.split(',');
		this.permissionedquerykeys = this.permissionedquerykeys ? JSON.parse(decodeURI(this.permissionedquerykeys)) : false;
		this.isR101 = this.analyticsDataModel.config.directoryName.toLowerCase() == 'default-r101';
		this.isR1 = ['default-r1', 'midco', 'hearst-r1'].includes(
			this.analyticsDataModel.config.directoryName.toLowerCase()
		);
		this.isDOOHenabled = this.analyticsDataModel.checkComponentForPermission(this.dooh_permission);
		this.isR104 = this.analyticsDataModel.config.directoryName.toLowerCase() == 'default-r104';
		let gamProduct = this.analyticsDataModel.config.products.filter((product) => product.productURL == 'gam');
		this.gamProductName = gamProduct.length > 0 ? gamProduct[0].productName : this.gamProductName;
		this.isR8 = this.analyticsDataModel.config.version.toUpperCase() == 'R8';
		this.tooltipOptions['theme'] = this.isR8 ? 'light r8-overview-summary' : 'dark';
		this.isEntravisionR103 =
			this.analyticsDataModel.config.directoryName.toLowerCase() === 'entravision-r103' ? true : false;
		this.requestData();
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	requestData(): void {
		this.showLoad = true;
		this.hasDoohCampaigns =
			this.analyticsDataModel.campaigns?.filter(
				(campaign) =>
					(campaign.permission.includes('has_dooh_access') || campaign.permission.includes('has_dooh_video_access')) &&
					campaign.selected
			).length > 0;
		this.widgetDataSubscription = this.analyticsService
			.processOverviewRequest(this.key, this.permissionedquerykeys)
			.subscribe((res: any) => {
				this.showLoad = false;
				if (res.success) {
					this.processResponseData(res);
				} else {
					this.summaryData = [];
				}
			});
	}

	processResponseData(response: any): void {
		this.summaryData = this.mapOverviewSummaryResponseToModel(response.data);
	}

	mapOverviewSummaryResponseToModel(responseArray: any[]): OverviewSummaryModel[] {
		const overviewSummary: OverviewSummaryModel[] = [];
		let count = 0;
		for (const response of responseArray) {
			const overviewSummaryObj: OverviewSummaryModel = {} as OverviewSummaryModel;
			overviewSummaryObj.productId = parseInt(response.product_id);
			overviewSummaryObj.mainId = parseInt(response.main_id);
			overviewSummaryObj.productName =
				response.product_name == 'O&O' ? (this.isR101 ? 'Newspaper.com ROS' : 'O&O') : response.product_name;
			overviewSummaryObj.productName =
				this.isR8 || this.isR104
					? overviewSummaryObj.productName.toUpperCase() == 'CTV' ||
					  overviewSummaryObj.productName.toUpperCase() == 'CONNECTED TV'
						? 'CTV/OTT'
						: overviewSummaryObj.productName.toUpperCase() == 'STREAMING AUDIO' ||
						  overviewSummaryObj.productName.toUpperCase() == 'RADIO'
						? this.isR104
							? 'Streaming Audio'
							: 'Audio'
						: overviewSummaryObj.productName
					: overviewSummaryObj.productName;
			overviewSummaryObj.isParent = UtilityService.toTrueOrFalse(overviewSummaryObj.mainId);
			overviewSummaryObj.order = overviewSummaryObj.isParent
				? this.productsOrder[overviewSummaryObj.productName]
				: this.getParentProductOrder(overviewSummary, overviewSummaryObj.productId);

			overviewSummaryObj.parentIndex = count;
			overviewSummaryObj.parentClass = overviewSummaryObj.isParent
				? this.getClassByIndex(overviewSummaryObj.parentIndex)
				: '';
			overviewSummaryObj.impressions =
				response.product_name == 'DOOH' && response.impressions != null
					? response.impressions
					: parseFloat(response.impressions);
			overviewSummaryObj.clicks = parseFloat(response.clicks);
			overviewSummaryObj.clickRate = this.calculateRate(overviewSummaryObj.clicks, overviewSummaryObj.impressions);
			overviewSummaryObj.viewThroughs = parseFloat(response.view_throughs);
			overviewSummaryObj.viewThroughRate = this.calculateRate(
				overviewSummaryObj.viewThroughs,
				overviewSummaryObj.impressions
			);
			overviewSummaryObj.visits = parseFloat(response.visits);
			overviewSummaryObj.visitRate = this.calculateRate(overviewSummaryObj.visits, overviewSummaryObj.impressions);
			overviewSummaryObj.exposures = parseFloat(response.exposures);
			overviewSummaryObj.adplays = parseFloat(response.ad_plays);
			if (overviewSummaryObj.isParent) {
				count++;
			}
			overviewSummary.push(overviewSummaryObj);
		}
		// sort only in case of it has television
		if (this.hasExposureColumn) {
			overviewSummary.sort((p1: any, p2: any) => {
				if (p1.order < p2.order) {
					return -1;
				} else if (p1.order > p2.order) {
					return 1;
				} else {
					return 0;
				}
			});
		}
		return overviewSummary;
	}

	calculateRate(entity: any, impressions: any): any {
		let rate = 'n/a';
		if (!isNaN(entity) && !isNaN(impressions)) {
			rate = isNaN((entity * 100) / impressions) ? '0.00%' : ((entity * 100) / impressions).toFixed(2) + '%';
		}
		return rate;
	}

	getClassByIndex(index: any): any {
		const colorIndex = index % this.partnerColors.length;
		return this.partnerColors[colorIndex].trim() + '-color-border-left';
	}

	getParentProductOrder(overviewSummary: any, productId: any): any {
		const product = overviewSummary.find((product: any) => {
			if (product.productId == productId && product.isParent) {
				return true;
			}
		});
		return product && product.order ? product.order : 0;
	}
}
